import posthog from 'posthog-js';

export type AnalyticsEvent =
  | 'trial_started'
  | 'contact_submitted'
  | 'tracking_search'
  | 'cta_click'
  | 'login_click';

export function track(event: AnalyticsEvent, properties?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return;

  posthog.capture(event, properties);
}
